import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ApikeyInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //console.log("ApikeyInterceptorService");

    /*request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`
      }
    });

    return next.handle(request);*/

    const changedReq = request.clone({
        headers: request.headers.set('x-auth-apikey', '42d3c293d651f38495be25d9b4d8c7413ae7bf05')
    });
    return next.handle(changedReq);

    //return next.handle(request);
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/apikey-interceptor.service.ts